import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snakeCaseToDotted',
})
export class SnakeCaseToDottedPipe implements PipeTransform {
  transform(value: string, prefix?: string): string {
    // Null/undefined guard
    if (!value || typeof value !== 'string') {
      return value;
    }

    // Handle empty string
    if (value.trim() === '') {
      return value;
    }

    // Convert: UPPERCASE_SNAKE_CASE -> lowercase.dotted.format
    const transformed = value.toLowerCase().replace(/_/g, '.');

    // Optionally prepend prefix
    return prefix ? `${prefix}.${transformed}` : transformed;
  }
}
